import _ from 'lodash';
import { preload, goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchInstructionsPage } from 'app/api/onboarding-api';
import Instructions from 'app/components/setup/instructions';
import features from 'app/common/containers/features';

const { getStringsForPage, getMarkdownStringsForPage, getSectionForPageByIdAndType } =
  contentfulModels;

const mapStateToProps = (state) => {
  const instructionsPage = _.get(state, 'onboarding.instructionsPage');
  return {
    pageStrings: getStringsForPage(instructionsPage),
    pageMarkdownStrings: getMarkdownStringsForPage(instructionsPage),
    headerArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage,
        'lets-get-started-aura',
        'supportArticle',
      ),
    },
    unboxArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage,
        'unbox-your-glowforge-aura',
        'supportArticle',
      ),
    },
    printHeadArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage,
        'install-print-head-aura',
        'supportArticle',
      ),
    },
    cuttingTrayArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage,
        'install-cutting-tray-aura',
        'supportArticle',
      ),
    },
  };
};

const preloadContent = ({ dispatch }) => Promise.all([dispatch(fetchInstructionsPage())]);

const mapDispatchToProps = dispatch => ({
  onNext: () => {
    dispatch(goto('/setup/exhaust'));
  },
});

const InstructionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(preload(preloadContent)(Instructions));

export default features(InstructionsContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/instructions.js